<template>
	<div id="butterflyView">
		<b-row class="mb-3">
			<b-col v-for="butterfly of butterflies.slice().reverse().filter(thisButterfly)" v-bind:key="butterfly['.key']">
				<h4><b>{{butterfly.scientificName}}</b></h4>
				<h5>{{butterfly.commonName}}</h5>
			</b-col>
		</b-row>

		<b-row class="mb-3">
			<b-col v-for="butterfly of butterflies.slice().reverse().filter(thisButterfly)" v-bind:key="butterfly['.key']">
				<b-button v-b-toggle.collapse-1 variant="info">Show More Info</b-button>
				<b-collapse id="collapse-1" class="mt-2" >
					<b-card style="background-color:#dedede;">
						<b-row>
							<b-col>
								<b-row>
									<b-col>
										<h5><b>General Information</b></h5>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										Family: {{butterfly.family}}
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										Sub Family: {{butterfly.subFamily}}
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										Estimated Life Span: {{(butterfly.longevity=== '' || butterfly.longevity==null)?'':butterfly.longevity+' Days'}} 
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										Host Plants: {{butterfly.hostPlant}}
									</b-col>
								</b-row>
							</b-col>
							<b-col>
								<b-row>
									<b-col>
										<h5><b>Species Range</b></h5>
									</b-col>
								</b-row>
								<b-row v-if="butterfly.northAmerica=='accepted'">
									<b-col>
										North America
									</b-col>
								</b-row>
								<b-row v-if="butterfly.southAmerica=='accepted'">
									<b-col>
										South America
									</b-col>
								</b-row>
								<b-row v-if="butterfly.europe=='accepted'">
									<b-col>
										Europe
									</b-col>
								</b-row>
								<b-row v-if="butterfly.africa=='accepted'">
									<b-col>
										Africa
									</b-col>
								</b-row>
								<b-row v-if="butterfly.australia=='accepted'">
									<b-col>
										Australia
									</b-col>
								</b-row>
								<b-row v-if="butterfly.asia=='accepted'">
									<b-col>
										Asia
									</b-col>
								</b-row>
								<b-row v-if="butterfly.antartica=='accepted'">
									<b-col>
										Antartica
									</b-col>
								</b-row>
								<b-row v-if="butterfly.unknown=='accepted'">
									<b-col>
										Unknown
									</b-col>
								</b-row>
							</b-col>
							<b-col>
								<b-row>
									<b-col>
										<h5><b>Garden Specific Information</b></h5>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										Estimated Number in flight: {{estimatedInFlight(butterfly)}}
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										Total number of pupae received: {{totalNumber(butterfly)}}
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										Last flown on: {{lastFlown(butterfly)}}
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										First flown on: {{firstFlown(butterfly)}}
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<hr>
						<b-row>
							<b-col>
								<b-row>
									<b-col>
										<h5><b>Food Source</b></h5>
									</b-col>
								</b-row>
								<b-row v-if="butterfly.flower_nectar">
									<b-col>
										Flower Nectar
									</b-col>
								</b-row>
								<b-row v-if="butterfly.fruit">
									<b-col>
										Fruit
									</b-col>
								</b-row>
							</b-col>
							<b-col>
								<b-row>
									<b-col>
										<h5><b>Habitat</b></h5>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										{{butterfly.habitat}}
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<br>
						<b-row>
							<b-col>
								<b-row>
									<b-col>
										<h5><b>Life History</b></h5>
									</b-col>
								</b-row>
								<b-row v-if="butterfly.flower_nectar">
									<b-col>
										Flower Nectar
									</b-col>
								</b-row>
								<b-row v-if="butterfly.fruit">
									<b-col>
										Fruit
									</b-col>
								</b-row>
							</b-col>
							<b-col>
								<b-row>
									<b-col>
										<h5><b>Fun Facts</b></h5>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										{{butterfly.funFact}}
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-card>
				</b-collapse>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<b-row class="noselect" style="cursor:pointer">
					<b-col cols="2" v-for="butterfly of butterflies.slice().reverse().filter(thisButterfly)" v-bind:key="butterfly['.key']" >
						<div v-if="!(butterfly.url==='')">
							<b-card
							style="max-width: 20rem;"
							class="mb-2 onHover text-center"
							v-b-modal="butterfly['.key']" >
							<b-img-lazy :src="butterfly.url" fluid alt="No image" class="mb-2"></b-img-lazy>
							<b-card-text class="text-center" >
								Main Image
							</b-card-text>
						</b-card>

						<b-modal v-bind:id="butterfly['.key']" size="lg" hide-footer hide-header >
							<b-button class="mb-2" style="float:right" variant="danger" @click="$bvModal.hide(butterfly['.key'])"><b-icon-x></b-icon-x></b-button>
							<div class="text-center"><b-img-lazy :src="butterfly.url" alt="No image" id="modalImg" style="width:100%;"></b-img-lazy></div>
							<b-row class="text-center"><b-col><h4>Main Image</h4></b-col></b-row>

						</b-modal>
					</div>


					<div v-else>
						<b-card
						style="max-width: 20rem;"
						class="mb-2 onHover text-center"
						v-b-modal="butterfly['.key']" >
						<img src="../assets/unknown.png" fluid alt="No image" class="mb-2 responsive" >

						<b-card-text class="text-center" >
							Main Image
						</b-card-text>
					</b-card>



					<b-modal v-bind:id="butterfly['.key']" size="lg" hide-footer hide-header >
						<b-button class="mb-2" style="float:right" variant="danger" @click="$bvModal.hide(butterfly['.key'])"><b-icon-x></b-icon-x></b-button>
						<div class="text-center">
							<img src="../assets/unknown.png" fluid alt="No image" class="mb-2 responsive">
						</div>
						<b-row class="text-center"><b-col><h4>Main Image</h4></b-col></b-row>

					</b-modal>
				</div>

			</b-col>
			<b-col cols="2" v-for="bImage of bImages.slice().reverse().filter(thisImages)" v-bind:key="bImage['.key']" v-b-modal="bImage['.key']" class="onHover">

				<b-card
				style="max-width: 20rem;"
				class="mb-2 onHover"
				v-b-modal="bImage['.key']">
				<b-img-lazy :src="bImage.url" fluid alt="No image" class="mb-2"></b-img-lazy>
				<b-card-text class="text-center" >
					{{bImage.description}}
				</b-card-text>
			</b-card>
			<b-modal v-bind:id="bImage['.key']" size="lg" hide-footer hide-header>
				<b-button class="mb-2" style="float:right" variant="danger" @click="$bvModal.hide(bImage['.key'])"><b-icon-x></b-icon-x></b-button>
				<b-img-lazy :src="bImage.url" alt="Fluid image" id="modalImg" style="width:100%"></b-img-lazy>
				<b-row class="text-center"><b-col><h4>{{bImage.description}}</h4></b-col></b-row>
			</b-modal>


		</b-col>
	</b-row>
</b-col>
</b-row>
</div>
</template>

<style>
#butterflyView {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	padding: 50px 50px 50px 50px;
}

.onHover:hover{
	opacity: 0.8
}	

.responsive {
	width: 100%;
	height: auto;
}

</style>

<script>
import { butterflyRef } from '../firebase'
import { bImagesRef } from '../firebase'
import { shipmentsRef } from '../firebase'
import { batchRef } from '../firebase'
export default {
	name: 'butterflyView',
	data () {
		return {
			butterflies: [],
			bImages: [],
			shipments: [],
			batches: [],
			id: null,
		}
	},
	firebase: {
		butterflies: butterflyRef,
		bImages: bImagesRef,
		shipments: shipmentsRef,
		batches: batchRef
	},
	created() {
		this.id = this.$route.params.id
	},
	methods: {
		thisImages(bImg){
			return bImg.id==this.id ? bImg:null;
		},
		thisButterfly(thisButterfly){
			return thisButterfly['.key']==this.id ? thisButterfly:null;
		},
		totalNumber(butterfly){
			var counter = 0;
			for(let i = 0; i<this.batches.length; i++){
				if(this.batches[i].speciesN == butterfly.scientificName){
					for(let j = 0; j<this.shipments.length; j++){
						if(this.shipments[j]['.key']==this.batches[i].id){
							counter += parseInt(this.shipments[j].numberReceived);
						}
					}
				}
			}
			return counter;
		},
		estimatedInFlight(butterfly){
			if(butterfly.longevity === '' || parseInt(butterfly.longevity) == 0){
				return 0;
			}

			var counter = 0;
			for(let i = 0; i<this.batches.length; i++){
				if(this.batches[i].speciesN == butterfly.scientificName){
					for(let j = 0; j<this.shipments.length; j++){
						if(this.shipments[j]['.key']==this.batches[i].id){
							if(this.diffDate(new Date(this.shipments[j].arrivalDate), new Date()) <= parseInt(butterfly.longevity)){

								counter += parseInt(this.batches[i].released);
							}
						}
					}
				}
			}
			return counter;
		},
		diffDate(d1, d2){
			const date1 = new Date(d1);
			const date2 = new Date(d2);
			const diffTime = date2 - date1;
			const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
			return diffDays;
		},
		lastFlown(butterfly){
			var shipment = null
			for(let i = 0; i<this.batches.length; i++){
				if(this.batches[i].speciesN == butterfly.scientificName){
					for(let j = 0; j<this.shipments.length; j++){
						if(this.shipments[j]['.key']==this.batches[i].id){
							if(shipment == null){
								shipment = this.shipments[j];
							}else{
								var date1 = new Date(shipment.arrivalDate);
								var date2 = new Date(this.shipments[j].arrivalDate);
								if(date2.getTime() > date1.getTime()){
									shipment = this.shipments[j];
								}
							}
						}
					}
				}
			}
			return shipment?this.getFormattedDate(shipment.arrivalDate):'Never';
		},
		firstFlown(butterfly){
			var shipment = null
			for(let i = 0; i<this.batches.length; i++){
				if(this.batches[i].speciesN == butterfly.scientificName){
					for(let j = 0; j<this.shipments.length; j++){
						if(this.shipments[j]['.key']==this.batches[i].id){
							if(shipment == null){
								shipment = this.shipments[j];
							}else{
								var date1 = new Date(shipment.arrivalDate);
								var date2 = new Date(this.shipments[j].arrivalDate);
								if(date2.getTime() < date1.getTime()){
									shipment = this.shipments[j];
								}
							}
						}
					}
				}
			}
			return shipment?this.getFormattedDate(shipment.arrivalDate):'Never';
		},
		getFormattedDate(dateParam) {

			var date = new Date(dateParam);

			var month = date.getMonth()+1;

			var day = date.getDate()+1;

			var year = date.getFullYear();

			return month + "/" + day + "/" + year;

		}
	}
}
</script>
